<div class="grid">
  <div class="md:col-6 col-12">
    <p-card>
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Дата</label>
          <crm-datepicker
            [(value)]="document.date"
            [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.date"
            class="p-error">
            {{ errors.date | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Компания</label>
          <crm-company-single-select
            [(selectedCompany)]="document.company"
            (selectedCompanyChange)="changeCompany()"
            [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-company-single-select>
          <small
            *ngIf="errors?.company"
            class="p-error">
            {{ errors.company | join }}
          </small>
        </div>

        <p-messages
          *ngIf="!document.company"
          severity="info"
          styleClass="mb-3">
          <ng-template pTemplate="">
            <div class="flex gap-2 align-items-center">
              <i
                class="pi pi-exclamation-circle"
                style="font-size: 1.3rem"></i>
              <p>Для заполнения полей: "Тип документа", "Валюта", "Сумма" необходимо заполнить поле "Компания".</p>
            </div>
          </ng-template>
        </p-messages>

        <div class="field">
          <label class="font-medium required-field">Тип документа</label>
          <crm-document-type-single-select
            [(selectedDocumentType)]="document.documentType"
            [isError]="$any(errors?.documentType)"
            [disabled]="canDelete || !document.company"
            [showClear]="false"
            appendTo="body"></crm-document-type-single-select>
          <small
            *ngIf="errors?.documentType"
            class="p-error">
            {{ errors.documentType | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Валюта</label>
          <crm-currency-single-select
            [currencies]="currencies"
            [(selectedCurrency)]="document.currency"
            [customSearch]="true"
            [disabled]="!document.company"
            [isError]="$any(errors?.currency)"
            (selectedCurrencyChange)="document['rate'] = $event?.latestRate?.rate"
            appendTo="body"></crm-currency-single-select>
          <small
            *ngIf="errors?.currency"
            class="p-error">
            {{ errors.currency | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Сумма</label>
          <p-inputNumber
            [(ngModel)]="document.amount"
            [disabled]="!document.company"
            (onInput)="changeAmount($event.value)"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"></p-inputNumber>

          <div
            *ngIf="document.currency && document.currency?.isoCharacter !== 'RUB' && document.amount"
            class="text-medium text-lg uppercase mt-2">
            Сумма:
            {{ (document.amount || 0) * (document['rate'] || 0) | currency: 'RUB' : 'symbol' : '1.2-2' }}
          </div>
          <small
            *ngIf="errors?.amount"
            class="p-error">
            {{ errors.amount | join }}
          </small>
        </div>

        <div class="formgrid grid">
          <div class="field xl:col-6 col-12">
            <label class="font-medium">НДС</label>
            <crm-single-select
              [options]="nds"
              [(selectedItem)]="document.nds"
              (selectedItemChange)="changeValue()"
              [filter]="false"
              [styleClass]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.nds ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-single-select>
            <small
              *ngIf="errors?.nds"
              class="p-error">
              {{ errors.nds | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Сумма НДС</label>
            <p-inputNumber
              [(ngModel)]="document.vatAmount"
              [minFractionDigits]="2"
              [class]="errors?.vatAmount ? 'ng-invalid ng-dirty' : ''"
              [inputStyle]="{ width: '100%' }"
              styleClass="w-full"
              class="w-full"></p-inputNumber>
            <small
              *ngIf="errors?.vatAmount"
              class="p-error">
              {{ errors.vatAmount | join }}
            </small>
          </div>
        </div>

        <div
          *ngIf="canDelete && document?.bankDetails"
          class="field">
          <label class="font-medium">Расчетный счет</label>
          <crm-bank-details-auto-complete
            [bankDetails]="bankDetails"
            [(selectedBankDetail)]="document.bankDetails"
            [disabled]="true"
            [isError]="$any(errors?.bankDetails)"
            (bankDetailsSearch)="bankDetailsSearch.emit($event)"
            appendTo="body"></crm-bank-details-auto-complete>
          <small
            *ngIf="errors?.bankDetails"
            class="p-error">
            {{ errors.bankDetails | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Контрагент</label>
          <crm-contragent-auto-complete
            [(selectedContragent)]="document.contragent"
            [isError]="$any(errors?.contragent)"
            [customSearch]="false"
            appendTo="body">
          </crm-contragent-auto-complete>
          <small
            *ngIf="errors?.contragent"
            class="p-error">
            {{ errors.contragent | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Вид операции</label>
          <crm-operation-type-single-select
            [(selectedOperationType)]="document.operationType"
            [isError]="$any(errors?.operationType)"
            appendTo="body"></crm-operation-type-single-select>
          <small
            *ngIf="errors?.operationType"
            class="p-error">
            {{ errors.operationType | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
            Филиал
          </label>
          <crm-filial-single-select
            [(selectedFilial)]="document.filial"
            [isError]="$any(errors?.filial)"
            appendTo="body"></crm-filial-single-select>
          <small
            *ngIf="errors?.filial"
            class="p-error">
            {{ errors.filial | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
            Бизнес единица
          </label>
          <crm-unit-single-select
            [(selectedUnit)]="document.unit"
            [isError]="$any(errors?.unit)"
            appendTo="body"></crm-unit-single-select>
          <small
            *ngIf="errors?.unit"
            class="p-error">
            {{ errors.unit | join }}
          </small>
        </div>

        <div class="field">
          <label
            class="font-medium"
            [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired"
            >Бюджетная статья</label
          >
          <crm-direction-single-select
            [directions]="directions"
            [(selectedDirection)]="document.direction"
            [groupsDisabled]="true"
            [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-direction-single-select>
          <small
            *ngIf="errors?.direction"
            class="p-error">
            {{ errors.direction | join }}
          </small>
        </div>

        <div
          *ngIf="access.canReadDeal"
          class="field">
          <label class="font-medium">Сделка</label>
          <crm-deal-auto-complete
            [(selectedDeal)]="document.deal"
            [isError]="$any(errors?.deal)"
            appendTo="body"></crm-deal-auto-complete>
          <small
            *ngIf="errors?.deal"
            class="p-error">
            {{ errors.deal | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Договор</label>
          <crm-contract-single-select
            [(selectedEntity)]="document.contract"
            [setSelectedEntityId]="document.contract?.id"
            [styleClass]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-contract-single-select>
          <small
            *ngIf="errors?.contract"
            class="p-error">
            {{ errors.contract | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Центр затрат</label>
          <crm-cost-center-single-select
            [(selectedCostCenter)]="document.costCenter"
            [isError]="$any(errors?.costCenter)"
            appendTo="body"></crm-cost-center-single-select>
          <small
            *ngIf="errors?.costCenter"
            class="p-error">
            {{ errors.costCenter | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Комментарий</label>
          <crm-editor
            [(value)]="document.commentary"
            height="150px"></crm-editor>
          <small
            *ngIf="errors?.commentary"
            class="p-error">
            {{ errors.commentary | join }}
          </small>
        </div>

        <div
          *ngIf="access.canLockDocuments"
          class="field-checkbox">
          <p-checkbox
            [(ngModel)]="document.locked"
            [binary]="true"
            inputId="locked"></p-checkbox>
          <label [for]="'locked'">Игнорировать новые изменения</label>
        </div>

        <div
          *ngIf="!canDelete"
          class="field-checkbox">
          <p-checkbox
            [(ngModel)]="document.isCreateLinkedDocument"
            [binary]="true"
            inputId="isCreateLinkedDocument"></p-checkbox>
          <label [for]="'isCreateLinkedDocument'">Автоматически создать связанный документ</label>
        </div>

        <div class="mt-3 flex flex-wrap align-items-center gap-2">
          <ng-container *ngIf="canWrite">
            <crm-button
              *ngIf="canCreateBasedOn"
              label="Создать на основании"
              icon="pi pi-file"
              styleClass="w-auto p-button-secondary p-button-text"
              (onClick)="createBasedOnClick.emit()"></crm-button>

            <crm-button
              *ngIf="canCreateCopyOn"
              label="Копировать"
              icon="pi pi-copy"
              styleClass="w-auto p-button-secondary p-button-text"
              (onClick)="createCopyDocument({ copyId: document.code })"></crm-button>

            <crm-button
              *ngIf="canRepeatOn"
              label="Повторить"
              icon="pi pi-clone"
              styleClass="w-auto p-button-primary p-button-text"
              (onClick)="isShowRepeatDialog.set(true)"></crm-button>
          </ng-container>

          <a
            *ngIf="canCreateTemplate && access.canWriteTemplate"
            label="Создать шаблон"
            icon="pi pi-plus"
            class="w-auto p-button-secondary p-button-text"
            (click)="createTemplate({ documentId: document.code })"></a>
        </div>
      </div>
    </p-card>
  </div>

  <div
    *ngIf="canDelete"
    class="md:col-6 col-12">
    <div
      class="mb-3"
      *ngIf="isDocumentRelated(document)">
      <crm-document-split-widget [index]="index"></crm-document-split-widget>
    </div>
    <crm-document-history [index]="index"></crm-document-history>
  </div>
</div>

<div
  *ngIf="canWrite; else pdfButton"
  class="grid mt-3">
  <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
    <div>
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="onSave(document)"></crm-button>
      <ng-template [ngTemplateOutlet]="pdfButton"></ng-template>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <crm-button
      *ngIf="canDelete"
      [label]="'Удалить'"
      styleClass="p-button-danger p-button-text"
      (onClick)="delete.emit(document)"></crm-button>
  </div>
</div>

<ng-template #pdfButton>
  <div class="mt-3">
    <crm-button
      *ngIf="
        canDelete &&
        !document.company?.allDocumentTypesAllowed &&
        [DocumentKeyEnum.RECEIPT, DocumentKeyEnum.SALE].includes($any(document.documentType?.key))
      "
      label="Выгрузить в PDF"
      [loading]="loadingPdf"
      styleClass="p-button-text p-button-secondary mr-2"
      (onClick)="loadToPdf()"></crm-button>
  </div>
</ng-template>

<p-dialog
  header="Повторение документа"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isShowRepeatDialog"
  styleClass="frm-filters-ui-v2 frm-dialog-v2"
  [style]="{ width: '300px' }"
  (onHide)="months.set(0)">
  @if (!loadingRepeat()) {
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Повторить документ на следующие месяцы</label>
        <p-inputNumber
          [(ngModel)]="months"
          [min]="0"
          suffix=" мес."></p-inputNumber>
      </div>
    </div>

    <div class="mt-3">
      <crm-button
        label="Создать"
        [disabled]="!months()"
        styleClass="p-button-success"
        (onClick)="createRepeatDocuments()"></crm-button>
    </div>
  } @else {
    <crm-spinner top="mt-2 pt-2"></crm-spinner>
  }
</p-dialog>
